import {
    waitForCustomer,
    waitForProduct,
    waitForCart,
    waitForCategory,
    waitForProductReviews,
    waitForOrderReview,
    waitForSuccessPage,
} from 'sagas/analytics/helpers/waitFor';

import {
    resolveCartGlobalDataLayer,
    resolveCheckoutGlobalDataLayer,
    resolveProductGlobalDataLayer,
    resolveSuccessGlobalDataLayer,
    resolveInsuranceSuccessGlobalDataLayer,
    resolveCategoryGlobalDataLayer,
    resolveBlogPostGlobalDataLayer,
    resolveDefaultGlobalDataLayer,
} from '../globalDataLayerResolvers';

export type RouteGdlType = {
    waitForSagaBeforeResolve: Array<() => void>;
    resolveGlobalDataLayer: () => void;
};

export const PAGE_ROUTES: {[key: string]: RouteGdlType} = {
    checkout: {
        waitForSagaBeforeResolve: [waitForCustomer, waitForOrderReview],
        resolveGlobalDataLayer: resolveCheckoutGlobalDataLayer,
    },
    product: {
        waitForSagaBeforeResolve: [waitForCustomer, waitForProduct, waitForProductReviews],
        resolveGlobalDataLayer: resolveProductGlobalDataLayer,
    },
    productEdit: {
        waitForSagaBeforeResolve: [waitForCustomer, waitForProduct, waitForProductReviews],
        resolveGlobalDataLayer: resolveProductGlobalDataLayer,
    },
    successPage: {
        waitForSagaBeforeResolve: [waitForSuccessPage],
        resolveGlobalDataLayer: resolveSuccessGlobalDataLayer,
    },
    insuranceSuccessPage: {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: resolveInsuranceSuccessGlobalDataLayer,
    },
    cart: {
        waitForSagaBeforeResolve: [waitForCustomer, waitForCart],
        resolveGlobalDataLayer: resolveCartGlobalDataLayer,
    },
    category: {
        waitForSagaBeforeResolve: [waitForCustomer, waitForCategory],
        resolveGlobalDataLayer: resolveCategoryGlobalDataLayer,
    },
    blogPost: {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: resolveBlogPostGlobalDataLayer,
    },
    profile: {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: () => ({
            page_type_param1: 'MY_ACCOUNT',
            page_type_param2: 'MY_ACCOUNT',
        }),
    },
    rma: {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: () => ({
            page_type_param1: 'OTHER',
            page_type_param2: 'RMA',
        }),
    },
    error404: {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: () => ({
            page_type_param1: 'OTHER',
            page_type_param2: 'error404',
        }),
    },
    page: {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: () => ({
            page_type_param1: 'OTHER',
            page_type_param2: 'CMS',
        }),
    },
    home: {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: () => ({
            page_type_param1: 'HOMEPAGE',
            page_type_param2: 'HOMEPAGE',
        }),
    },
    blog: {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: () => ({
            page_name: 'GlassesUSA.com Blog -  Recent Posts',
            page_type_param1: 'OTHER',
            page_type_param2: 'BLOG',
        }),
    },
    resetPassword: {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: () => ({
            page_type_param1: 'OTHER',
            page_type_param2: 'CHANGE_FORGOTTEN',
        }),
    },
};

/**
 * Get router resolver
 * @param {string} page - name page
 * @returns {SagaIterator} - router resolver
 */
export function* getRouterResolver(page: string) {
    if (page in PAGE_ROUTES) {
        return yield PAGE_ROUTES[page];
    }

    return {
        waitForSagaBeforeResolve: [waitForCustomer],
        resolveGlobalDataLayer: resolveDefaultGlobalDataLayer,
    };
}
